import dynamic from 'next/dynamic';
import { GetServerSideProps } from 'next';

import getHashtagProps from 'templates/Hashtag/utils/getHashtagProps';

import type { HashtagProps } from 'types/hashtag';
import type { SSRContext } from 'types/SSRContext';

export const getServerSideProps: GetServerSideProps<HashtagProps> = async ({
  query,
  req,
  res,
}: SSRContext) => {
  const { category = 'most-edited', type = 'images', page, tag } = query;
  const encodedTag = encodeURIComponent(tag as string);

  const params = {
    page: Number(page) || 1,
    tag: encodedTag,
    category,
    type,
  };

  const pageProps = await getHashtagProps(req, res, params);

  return {
    props: {
      ...pageProps,
    },
  };
};

const Hashtag = dynamic(() => import('templates/Hashtag'));

export default Hashtag;
